import React from 'react';
import {Outlet} from "react-router-dom";
import {SidebarProvider, useSidebar} from "../../context/SidebarContext";
import {LayoutSidebar} from "../../Layout";
import {TopBar} from "./TopBar";

function AppLayoutInner() {
    const {isCollapsed, isMobile, isMobileOpen, closeMobileSidebar} = useSidebar();

    const mainClass = [
        'app-layout-v2-main',
        isCollapsed ? 'sidebar-collapsed' : '',
        isMobile ? 'sidebar-hidden' : '',
    ].filter(Boolean).join(' ');

    return (
        <div className="app-layout-v2">
            <LayoutSidebar/>
            {isMobile && isMobileOpen && (
                <div className="sidebar-v2-overlay" onClick={closeMobileSidebar}/>
            )}
            <div className={mainClass}>
                <TopBar/>
                <div className="app-layout-v2-content">
                    <Outlet/>
                </div>
            </div>
        </div>
    );
}

export function AppLayout() {
    return (
        <SidebarProvider>
            <AppLayoutInner/>
        </SidebarProvider>
    );
}
